/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_UpcomingInputs */

const th_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังจะถึง`)
};

const en_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const ja_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始前`)
};

const zh_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将开始`)
};

const es_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente`)
};

const pt_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve`)
};

const id_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendatang`)
};

const fr_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir`)
};

const tl_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paparating`)
};

const vi_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp tới`)
};

const ko_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예정`)
};

const de_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorstehend`)
};

const ru_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоит`)
};

const tr_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan`)
};

const it_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In arrivo`)
};

const pl_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzący`)
};

const uk_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попереду`)
};

const hi_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी`)
};

const ar_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قادمة`)
};

const ms_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akan datang`)
};

const bn_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আসন্ন`)
};

const zh_tw2_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將開始`)
};

const zh_hk2_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將開始`)
};

const ur_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آنے والا`)
};

const fa_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیشِ‌رو`)
};

const sw_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unaokuja`)
};

const nl_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komt eraan`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Status_UpcomingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const status_upcoming = /** @type {((inputs?: Status_UpcomingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_UpcomingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_status_upcoming(inputs)
	if (locale === "ja") return ja_status_upcoming(inputs)
	if (locale === "zh") return zh_status_upcoming(inputs)
	if (locale === "es") return es_status_upcoming(inputs)
	if (locale === "pt") return pt_status_upcoming(inputs)
	if (locale === "id") return id_status_upcoming(inputs)
	if (locale === "fr") return fr_status_upcoming(inputs)
	if (locale === "tl") return tl_status_upcoming(inputs)
	if (locale === "vi") return vi_status_upcoming(inputs)
	if (locale === "ko") return ko_status_upcoming(inputs)
	if (locale === "de") return de_status_upcoming(inputs)
	if (locale === "ru") return ru_status_upcoming(inputs)
	if (locale === "tr") return tr_status_upcoming(inputs)
	if (locale === "it") return it_status_upcoming(inputs)
	if (locale === "pl") return pl_status_upcoming(inputs)
	if (locale === "uk") return uk_status_upcoming(inputs)
	if (locale === "hi") return hi_status_upcoming(inputs)
	if (locale === "ar") return ar_status_upcoming(inputs)
	if (locale === "ms") return ms_status_upcoming(inputs)
	if (locale === "bn") return bn_status_upcoming(inputs)
	if (locale === "zh-TW") return zh_tw2_status_upcoming(inputs)
	if (locale === "zh-HK") return zh_hk2_status_upcoming(inputs)
	if (locale === "ur") return ur_status_upcoming(inputs)
	if (locale === "fa") return fa_status_upcoming(inputs)
	if (locale === "sw") return sw_status_upcoming(inputs)
	if (locale === "nl") return nl_status_upcoming(inputs)
	return en_status_upcoming(inputs)
});